export default __webpack_public_path__ + "static/Streamline-And-Automate-Clinical-Tasks-34a49bea0b2d9176bcc1f1e27e56aed1.webp";